import { unformat } from 'accounting';
import classNames from 'classnames';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { IconButton } from './IconButton';

// Styles
const s = require('./Search.css');
const cancelIcon = require('assets/close orange icon.svg');

// Types
export type SearchOptionValue = string | number | null;

// Interfaces
export interface ISearchOption {
    key?: string;
    value: SearchOptionValue;
    label: string;
}

// Props
interface ISearchProps {
    innerRef?: (ref: HTMLDivElement) => void;
    onValueChange?: (value: string) => void;
    onOptionChange?: (value: SearchOptionValue) => void;
    id?: string;
    className?: string;
    classNameForLabel?: string;
    classNameForField?: string;
    classNameForOptions?: string;
    label?: string;
    options?: ISearchOption[];
    selectedOption?: SearchOptionValue;
    placeholder?: string;
    autoFocus?: boolean;
    value?: string;
    isValueClearable?: boolean;
    clearOnlySearchValue?: boolean;
}

// Component
@observer
export class Search extends React.Component<ISearchProps, {}> {
    private get defaultProps(): ISearchProps {
        return {
            label: '',
            options: [],
            selectedOption: null,
            placeholder: '',
            autoFocus: false,
            value: '',
            isValueClearable: false,
            clearOnlySearchValue: false,
        };
    }

    private optionsList: HTMLSelectElement | null = null;

    @computed
    private get searchNotEmpty(): boolean {
        return typeof this.props.onValueChange !== 'undefined' &&
            this.props.value
            ? true
            : false;
    }

    public render() {
        return (
            <div
                ref={this.referenceContainer}
                className={classNames(s.container, this.props.className)}
            >
                <label
                    className={s.wrapper}
                    htmlFor={this.props.id || undefined}
                >
                    {this.props.label && (
                        <p
                            className={classNames(
                                s.label,
                                this.props.classNameForLabel
                            )}
                        >
                            <span>{this.props.label}</span>
                        </p>
                    )}

                    {this.props.onValueChange && (
                        <input
                            id={this.props.id || undefined}
                            className={classNames(
                                s.field,
                                this.props.classNameForField
                            )}
                            type="text"
                            autoFocus={this.props.autoFocus}
                            placeholder={this.props.placeholder}
                            value={this.props.value}
                            onChange={this.changeValue}
                        />
                    )}

                    {this.props.options && this.props.options.length > 0 && (
                        <select
                            ref={this.referenceOptionsList}
                            id={
                                this.props.id &&
                                typeof this.props.onValueChange === 'undefined'
                                    ? this.props.id
                                    : undefined
                            }
                            className={classNames(
                                s.options,
                                this.props.classNameForOptions
                            )}
                            onChange={this.changeOption}
                            value={
                                typeof this.props.selectedOption ===
                                    'undefined' ||
                                this.props.selectedOption === null
                                    ? 'null'
                                    : this.props.selectedOption
                            }
                        >
                            {this.props.options.map(activity => (
                                <option
                                    key={activity.key || activity.value}
                                    value={activity.value}
                                >
                                    {activity.label}
                                </option>
                            ))}
                        </select>
                    )}

                    {this.props.onValueChange && this.props.isValueClearable && (
                        <IconButton
                            className={classNames(s.clearButton, {
                                [s.visible]: this.searchNotEmpty,
                            })}
                            iconClassName={s.clearIcon}
                            labelClassName={s.clearLabel}
                            onClick={this.clearSearch}
                            icon={cancelIcon}
                            label="Clear"
                            labelOnRight={false}
                        />
                    )}
                </label>
            </div>
        );
    }

    private referenceContainer = (ref: HTMLDivElement) => {
        if (this.props.innerRef) {
            this.props.innerRef(ref);
        }
    };

    private referenceOptionsList = (ref: HTMLSelectElement) =>
        (this.optionsList = ref);

    private changeOption = (e: React.ChangeEvent<HTMLSelectElement>) => {
        if (this.optionsList && this.props.onOptionChange) {
            const val = this.optionsList.value;

            // Return null
            if (val === null || val === 'null' || val === 'NULL') {
                this.props.onOptionChange(null);
                return;
            }

            // Check if value is a number
            if (
                isNaN(val as any) ? /^[0-9|,|.|-| ]*$/.test(val) : val !== null
            ) {
                this.props.onOptionChange(unformat(val));
                return;
            }

            this.props.onOptionChange(val);
        }
    };

    private changeValue = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (this.props.onValueChange) {
            this.props.onValueChange(e.target.value);
        }
    };

    private clearSearch = () => {
        if (this.props.onValueChange && this.props.value) {
            this.props.onValueChange('');
        }

        if (
            this.props.clearOnlySearchValue === false &&
            this.props.onOptionChange &&
            this.props.options &&
            this.props.selectedOption !== null
        ) {
            this.props.onOptionChange(null);
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/action/Search.tsx